import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { showError, showSuccess } from '../utils/alerts';
import { API_BASE_URL } from '../config';
import '../styles/components/AsientosForm.css';

const AsientosForm = ({ token, id_company }) => {
    const [formData, setFormData] = useState({
        fecha: '',
        descripcion: '',
        tipo: '',
        categoria: ''
    });
    const [debeEntries, setDebeEntries] = useState([{ cuenta: '', monto: '' }]);
    const [haberEntries, setHaberEntries] = useState([{ cuenta: '', monto: '' }]);

    const formatNumber = (value) => {
        const numericValue = value.replace(/\./g, '').replace(/\D/g, '');
        return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    const [cuentas, setCuentas] = useState([]);

    useEffect(() => {
        const fetchCuentas = async () => {
            try {
                const response = await axios.get(
                    `${API_BASE_URL}/api/clasificador-cuentas`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setCuentas(response.data);
            } catch (error) {
                console.error('Error al obtener cuentas:', error);
            }
        };
        if (token) {
            fetchCuentas();
        }
    }, [token]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleDebeChange = (index, field, value) => {
        const updated = [...debeEntries];
        updated[index][field] = field === 'monto' ? formatNumber(value) : value;
        setDebeEntries(updated);
    };

    const handleHaberChange = (index, field, value) => {
        const updated = [...haberEntries];
        updated[index][field] = field === 'monto' ? formatNumber(value) : value;
        setHaberEntries(updated);
    };

    const addDebeEntry = () => {
        setDebeEntries([...debeEntries, { cuenta: '', monto: '' }]);
    };

    const addHaberEntry = () => {
        setHaberEntries([...haberEntries, { cuenta: '', monto: '' }]);
        
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
             const payload = {
                ...formData,
                debeEntries: debeEntries.map(d => ({
                    cuenta: d.cuenta,
                    monto: d.monto ? parseFloat(d.monto.toString().replace(/\./g, '')) : 0
                })),
                haberEntries: haberEntries.map(h => ({
                    cuenta: h.cuenta,
                    monto: h.monto ? parseFloat(h.monto.toString().replace(/\./g, '')) : 0
                })),
                id_company
            };
            const response = await axios.post(`${API_BASE_URL}/api/asientos`, payload, {
                
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            showSuccess(response.data);
            setFormData({ fecha: '', descripcion: '', tipo: '', categoria: '' });
            setDebeEntries([{ cuenta: '', monto: '' }]);
            setHaberEntries([{ cuenta: '', monto: '' }]);
            
        } catch (error) {
            console.error('Error al crear asiento contable:', error);
            showError('Hubo un error al crear el asiento contable');        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="input-icon">
                <input
                    type="text"
                    name="fecha"
                    value={formData.fecha}
                    onChange={handleChange}
                    placeholder="dd-mm-aaaa"
                    onFocus={(e) => (e.target.type = 'date')}
                    onBlur={(e) => {
                        if (e.target.value === '') e.target.type = 'text';
                    }}
                    required
                />
            </div>
            {debeEntries.map((entry, idx) => (
                <div key={`debe-${idx}`}> 
                    <select value={entry.cuenta} onChange={(e) => handleDebeChange(idx, 'cuenta', e.target.value)} required>
                        <option value="">Cuenta Debe</option>
                        {cuentas.map((c) => (
                            <option key={c.nombre_cuenta} value={c.nombre_cuenta}>{c.nombre_cuenta}</option>
                        ))}
                    </select>
                    <input type="text" value={entry.monto} onChange={(e) => handleDebeChange(idx, 'monto', e.target.value)} placeholder="Debe" required />
                </div>
            ))}
            <button type="button" onClick={addDebeEntry}>Añadir Debe</button>
            {haberEntries.map((entry, idx) => (
                <div key={`haber-${idx}`}> 
                    <select value={entry.cuenta} onChange={(e) => handleHaberChange(idx, 'cuenta', e.target.value)} required>
                        <option value="">Cuenta Haber</option>
                        {cuentas.map((c) => (
                            <option key={c.nombre_cuenta} value={c.nombre_cuenta}>{c.nombre_cuenta}</option>
                        ))}
                    </select>
                    <input type="text" value={entry.monto} onChange={(e) => handleHaberChange(idx, 'monto', e.target.value)} placeholder="Haber" required />
                </div>
            ))}
            <button type="button" onClick={addHaberEntry}>Añadir Haber</button>
             
            
            <input type="text" name="descripcion" value={formData.descripcion} onChange={handleChange} placeholder="Descripción" required />
            <input type="text" name="tipo" value={formData.tipo} onChange={handleChange} placeholder="Tipo (Ingreso / Egreso)"  />
            <input type="text" name="categoria" value={formData.categoria} onChange={handleChange} placeholder="Categoría" />
            <button type="submit">Crear Asiento Contable</button>
        </form>
    );
};

export default AsientosForm;